import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const VerticalLineIcon = ({
  color,
  width = 18,
  height = 18,
  ...rest
}: {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
  [x: string]: unknown;
}) => {
  const { token } = useToken();
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M9.84375 1.6875V16.3125C9.84375 16.5363 9.75485 16.7509 9.59662 16.9091C9.43839 17.0674 9.22378 17.1562 9 17.1562C8.77622 17.1562 8.56161 17.0674 8.40338 16.9091C8.24514 16.7509 8.15625 16.5363 8.15625 16.3125V1.6875C8.15625 1.46372 8.24514 1.24911 8.40338 1.09088C8.56161 0.932645 8.77622 0.84375 9 0.84375C9.22378 0.84375 9.43839 0.932645 9.59662 1.09088C9.75485 1.24911 9.84375 1.46372 9.84375 1.6875Z"
        fill={color ?? token.colorText}
      />
    </svg>
  );
};

export default VerticalLineIcon;
